import React, { PureComponent } from 'react'
import { Dispatch } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'

import { 
  toggleShouldConfirmRevert, 
  addNewSetting, 
  updateSettingsIds, 
  setImageStatus 
} from 'store/actions/settings.actions'

import Modal from 'components/Common/Modal/Modal'
import Button from 'components/Common/Buttons/Button/Button'
import Checkbox from 'components/Common/Checkbox/Checkbox'
import IconButton from 'components/Common/Buttons/IconButton/IconButton'
import { ReactComponent as RevertIcon } from 'assets/images/icons/i-revert.svg'

import { setCropperChangedStatus, updateCropperValues } from 'store/actions/cropper.actions'
import { setResizeChangedStatus, updateResizeValues } from 'store/actions/resize.actions'
import { checkHasCommittedChanges, getLastSetting } from '../../helpers/util'


/* TODO разобраться с типами: где и как их описываем */

type RevertControlStateType = {
  isOpenModal: boolean
}

type RevertControlProps = {
  settingsList: Array<object>,
  currentSettingId: number,
  imageSrc: string,
  imageData: ImageData,
  t: (string: string) => string,
  dispatchAddNewSetting: (object: object) => void,
  dispatchUpdateSettingsIds: (id: number) => void,
  lastSettingId: number,
  dispatchToggleShouldConfirmRevert: () => void,
  shouldConfirmRevert: boolean,
  dispatchUpdateCropperValues: (values: any) => void,
  activePresetId: number,
  cropper: object,
  dispatchSetCropperChangedStatus: (val: boolean) => void,
  resize: object,
  dispatchUpdateResizeValues: (values: object) => void,
  dispatchSetResizeChangedStatus: (values: boolean) => void,
  dispatchSetImageStatus: () => void
}

type ImageStoreType = {
  imageSrc: string,
  imageData: ImageData
}

type SettingStoreType = {
  shouldConfirmRevert: boolean,
  currentSettingId: number,
  settingsList: Array<object>,
  lastSettingId: number
}

type CropperStoreType = {
  activePresetId: number,
  cropper: object
}

type ResizeStoreType = {
  resize: object
}

type MapStateToPropsType = {
  imageStore: ImageStoreType,
  settingsStore: SettingStoreType,
  cropperStore: CropperStoreType,
  resizeStore: ResizeStoreType
}

class RevertControl extends PureComponent<RevertControlProps, RevertControlStateType> {
  constructor(props: RevertControlProps) {
    super(props)

    this.state = {
      isOpenModal: false
    }
  }

  onRevertBtnClick = () => {
    const { shouldConfirmRevert } = this.props

    if (!shouldConfirmRevert) {
      this.onOpenModal()
    } else {
      this.resetAdjust()
    }
  }

  onCloseModal = () => {
    this.setState({ isOpenModal: false })
  }

  onOpenModal = () => {
    this.setState({ isOpenModal: true })
  }

  resetAdjust = () => {
    const {
      imageSrc,
      currentSettingId,
      dispatchAddNewSetting,
      dispatchUpdateSettingsIds,
      imageData,
      dispatchUpdateCropperValues,
      cropper,
      dispatchSetCropperChangedStatus,
      dispatchUpdateResizeValues,
      dispatchSetResizeChangedStatus,
      dispatchSetImageStatus,
      resize,
      settingsList,
    } = this.props

    if (!imageSrc) return

    const lastSetting = getLastSetting(settingsList, currentSettingId)
    // replace a setting if it is not committed
    const nextSettingId = !lastSetting.isCommitted ? currentSettingId : currentSettingId + 1

    dispatchUpdateSettingsIds(nextSettingId)
    dispatchAddNewSetting({
      name: 'revert',
      id: nextSettingId,
      isCommitted: true,
      values: {
        brightness: 0,
        contrast: 0,
        saturation: 0,
        grayscale: 0,
        dogpatch: 0,
        aden: 0,
        hudson: 0,
        perpetua: 0,
      },
      imageData,
    })

    const newResize = {
      ...resize,
      id: 0,
    }

    dispatchUpdateCropperValues({
      ...cropper,
      activePresetId: 0,
      id: 0
    })
    dispatchSetCropperChangedStatus(false)

    dispatchUpdateResizeValues(newResize)
    dispatchSetResizeChangedStatus(false)
    dispatchSetImageStatus()

    if (this.state.isOpenModal) {
      this.onCloseModal()
    }
  }

  onChangeCheckbox = () => {
    const { dispatchToggleShouldConfirmRevert } = this.props
    dispatchToggleShouldConfirmRevert()
  }

  render() {
    const { isOpenModal } = this.state
    const {
      t,
      imageSrc,
      settingsList,
      currentSettingId,
      shouldConfirmRevert
    } = this.props

    return (
      <>
        <IconButton
          onClick={this.onRevertBtnClick}
          disabled={
            !imageSrc ||
            !checkHasCommittedChanges(settingsList, currentSettingId)
          }
          caption={t('buttons.revert')}
        >
          <RevertIcon />
        </IconButton>
        <Modal isOpen={isOpenModal} onCloseModal={this.onCloseModal}>
          <div className="modal__body">
            <div className="modal__text">
              {t('modals.revert-settings')}
            </div>
            <Checkbox
              label={t('toggles.dont-ask-again')}
              value={shouldConfirmRevert}
              onChange={this.onChangeCheckbox}
            />
          </div>
          <div className="modal__buttons">
            <Button variant="ghost" onClick={this.onCloseModal}>
              {t('buttons.no')}
            </Button>
            <div className="modal__buttons-separator" />
            <Button onClick={this.resetAdjust}>
              {t('buttons.yes')}
            </Button>
          </div>
        </Modal>
      </>
    )
  }
}

const mapStateToProps = ({
  imageStore: { imageSrc, imageData },
  settingsStore: {
    shouldConfirmRevert,
    currentSettingId,
    settingsList,
    lastSettingId
  },
  cropperStore: {
    activePresetId,
    cropper
  },
  resizeStore: {
    resize
  }
}: MapStateToPropsType)  => ({
  imageSrc,
  imageData,
  shouldConfirmRevert,
  settingsList,
  currentSettingId,
  lastSettingId,
  activePresetId,
  cropper
})

/* TODO ActionTypes */

const mapDispatchToProps = (dispatch: Dispatch) => ({
  dispatchToggleShouldConfirmRevert: () => dispatch(toggleShouldConfirmRevert()),
  dispatchAddNewSetting: (setting: object) => dispatch(addNewSetting(setting)),
  dispatchUpdateSettingsIds: (id: number) => dispatch(updateSettingsIds(id)),
  dispatchUpdateCropperValues: (values: any) => dispatch(updateCropperValues(values)),
  dispatchSetCropperChangedStatus: (status: boolean) => dispatch(setCropperChangedStatus(status)),
  dispatchUpdateResizeValues: (values: any) => dispatch(updateResizeValues(values)),
  dispatchSetResizeChangedStatus: (status: boolean) => dispatch(setResizeChangedStatus(status)),
  dispatchSetImageStatus: () => dispatch(setImageStatus()) 
})

/* TODO: type */
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(RevertControl as any) as any)
